import axios from 'axios';

// In Produktion laeuft das Frontend hinter nginx, das /api/ auf den
// Backend-Container proxied (siehe nginx.conf) -> relative URL genuegt.
// In der lokalen Entwicklung laeuft das Backend separat auf Port 8000.
export const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
});

// Request-Interceptor: Token aus localStorage an jeden Request haengen.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fleet_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response-Interceptor: bei 401 (abgelaufenes/ungueltiges Token) ausloggen
// und neu laden -> App.tsx zeigt dann wieder die LoginPage.
// Nur reloaden, wenn zuvor tatsaechlich ein Token vorlag -- sonst wuerde
// jeder fehlgeschlagene Login-Versuch (falsches Passwort -> ebenfalls 401)
// die Seite neu laden, bevor der Nutzer die Fehlermeldung sehen kann.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('fleet_token')) {
      localStorage.removeItem('fleet_token');
      localStorage.removeItem('fleet_user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
